(() => {
  const makeBundleId = () =>
    'core-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);

  const bindCoreBundle = (scope = document) => {
    scope.querySelectorAll('[data-core-bundle]').forEach((form) => {
      if (form.dataset.bundleReady === 'true') return;
      form.dataset.bundleReady = 'true';

      const submit = form.querySelector('.add-to-cart');
      const error = form.querySelector('[data-core-cart-error]');
      const qtyInput = form.querySelector('[data-core-qty]');
      const wrapQtyInput = form.querySelector('[data-wrap-quantity]');
      let pending = false;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (pending || !form.reportValidity()) return;

        const root = form.closest('[data-core-section]') || document;
        const selectedWrap = root.querySelector('input[data-wrap-color]:checked');
        const coreVariantId = Number(form.dataset.coreVariant);
        const wrapVariantId = Number(selectedWrap?.value);
        const quantity = Math.max(1, Number(qtyInput?.value || 1));
        const wrapColor = selectedWrap?.dataset.wrapColor || '';
        const wrapLabel = wrapColor ? wrapColor.charAt(0).toUpperCase() + wrapColor.slice(1) : '';

        if (!coreVariantId || !wrapVariantId || !wrapLabel) {
          if (error) {
            error.textContent = 'Please choose a wrap color.';
            error.hidden = false;
          }
          return;
        }

        if (wrapQtyInput) wrapQtyInput.value = String(quantity);
        pending = true;
        if (error) error.hidden = true;
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Adding…';
        }

        const bundleId = makeBundleId();

        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({
              items: [
                {
                  id: coreVariantId,
                  quantity,
                  properties: {
                    '_pp_bundle_id': bundleId,
                    '_pp_bundle_role': 'parent',
                    '_pp_bundle_type': 'core-wrap',
                    'Wrap Color': wrapLabel
                  }
                },
                {
                  id: wrapVariantId,
                  quantity,
                  properties: {
                    '_pp_bundle_id': bundleId,
                    '_pp_bundle_role': 'child',
                    '_pp_bundle_type': 'core-wrap',
                    '_pp_bundle_parent_variant': String(coreVariantId),
                    '_pp_bundle_color': wrapLabel
                  }
                }
              ]
            })
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Unable to add CORE to cart. Please try again.');
          }
          window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        } catch (failure) {
          if (error) {
            error.textContent = failure.message;
            error.hidden = false;
          }
          pending = false;
          if (submit) {
            submit.disabled = false;
            submit.textContent = 'Add to Cart';
          }
        }
      });
    });
  };

  bindCoreBundle();
  document.addEventListener('shopify:section:load', (event) => bindCoreBundle(event.target));
})();

(() => {
 const init = (root) => {
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mainImage = root.querySelector('#gallery-main-image');
      const thumbs = Array.from(root.querySelectorAll('.gallery-thumbs .thumb'));
      const previousButton = root.querySelector('.gallery-arrow.prev');
      const nextButton = root.querySelector('.gallery-arrow.next');
      const imageCount = root.querySelector('.gallery-count');
      const accessoriesToggle = root.querySelector('#accessories-toggle');
      const accessoriesDrawer = root.querySelector('#accessories-drawer');
      const accessoriesToggleLabel = accessoriesToggle.querySelector('.toggle-label');
      const accessoryMediaButtons = Array.from(root.querySelectorAll('.accessory-media'));
      const wrapColorInputs = Array.from(root.querySelectorAll('input[data-wrap-color]'));
      const colorImages = Object.fromEntries(['brown','beige','black'].map(color=>[color,{src:root.dataset[color+'Image'],alt:color[0].toUpperCase()+color.slice(1)+' Porch Potty CORE with synthetic grass and red training hydrant'}]));
      let activeIndex = 0;
      let touchStartX = 0;
      let touchStartY = 0;

      const selectImage = (thumb) => {
        activeIndex = thumbs.indexOf(thumb);
        thumbs.forEach((item) => {
          item.classList.remove('active');
          item.removeAttribute('aria-current');
        });
        thumb.classList.add('active');
        thumb.setAttribute('aria-current', 'true');
        mainImage.onload = () => { mainImage.style.opacity = '1'; }; mainImage.onerror = () => { mainImage.style.opacity = '1'; }; mainImage.style.opacity = '0.35';
        mainImage.src = thumb.dataset.src;
        mainImage.alt = thumb.dataset.alt;
        mainImage.classList.toggle('fit-contain', thumb.dataset.fit === 'contain');
        imageCount.textContent = `${activeIndex + 1} / ${thumbs.length}`;
        thumb.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        if(mainImage.complete)mainImage.style.opacity='1';
      };

      const moveGallery = (direction) => {
        const nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
        selectImage(thumbs[nextIndex]);
      };

      previousButton.addEventListener('click', () => moveGallery(-1));
      nextButton.addEventListener('click', () => moveGallery(1));

      mainImage.parentElement.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      mainImage.parentElement.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        moveGallery(deltaX < 0 ? 1 : -1);
      }, { passive: true });

      accessoriesToggle.addEventListener('click', () => {
        const isOpen = accessoriesToggle.getAttribute('aria-expanded') === 'true';
        accessoriesToggle.setAttribute('aria-expanded', String(!isOpen));
        accessoriesDrawer.hidden = isOpen;
        accessoriesToggleLabel.textContent = isOpen ? 'Shop Add-ons' : 'Hide Add-ons';
        if (!isOpen) accessoriesDrawer.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
      });

      accessoryMediaButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const isLifestyle = button.getAttribute('aria-pressed') === 'true';
          button.setAttribute('aria-pressed', String(!isLifestyle));
          button.classList.toggle('show-lifestyle', !isLifestyle);
        });
      });

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => selectImage(thumb));
        thumb.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = thumbs[(index + direction + thumbs.length) % thumbs.length];
          next.focus();
          selectImage(next);
        });
      });

      wrapColorInputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked || !colorImages[input.dataset.wrapColor]) return;
          const selectedColor = colorImages[input.dataset.wrapColor];
          const firstThumb = thumbs[0];
          firstThumb.dataset.src = selectedColor.src;
          firstThumb.dataset.alt = selectedColor.alt;
          firstThumb.setAttribute('aria-label', `View ${input.dataset.wrapColor} CORE product image`);
          const thumbnailImage = firstThumb.querySelector('img');
          thumbnailImage.src = selectedColor.src;
          selectImage(firstThumb);
        });
      });

      const variantSelect = root.querySelector('[data-core-variant]');
      const updateVariant = () => {
        const option = variantSelect.selectedOptions[0];
        root.querySelector('[data-core-price]').textContent=option.dataset.price;
        const submit=root.querySelector('.add-to-cart');
        submit.disabled=option.dataset.available!=='true';
        (submit.querySelector('[data-submit-label]')||submit).textContent=submit.disabled?'Sold out':'Add to Cart';
        const color=Object.keys(colorImages).find(c=>option.dataset.color.includes(c));
        if(color){thumbs[0].dataset.src=colorImages[color].src;thumbs[0].dataset.alt=colorImages[color].alt;thumbs[0].querySelector('img').src=colorImages[color].src;selectImage(thumbs[0]);}
        if(location.pathname.startsWith('/products/')){const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);}
      };
      variantSelect?.addEventListener('change',updateVariant);
      if(variantSelect)updateVariant();



      const slider=root.querySelector('#productSlider');
      const slide=(direction)=>{const card=slider.firstElementChild;slider.scrollBy({left:direction*(card.getBoundingClientRect().width+(parseFloat(getComputedStyle(slider).gap)||16)),behavior:reduced?'auto':'smooth'});};
      root.querySelector('.compare-prev')?.addEventListener('click',()=>slide(-1));
      root.querySelector('.compare-next')?.addEventListener('click',()=>slide(1));
      const dialog=root.querySelector('[data-compare]');let trigger;
      root.querySelectorAll('[data-core-compare]').forEach(b=>b.addEventListener('click',()=>{trigger=b;dialog.showModal();}));
      dialog.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>dialog.close()));
      dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>trigger?.focus());
 };
 const placeMegaBackInStock = (scope = document) => {
   scope.querySelectorAll('.pp-mega[data-core-section]').forEach((root) => {
     const purchaseCard = root.querySelector('.purchase-card');
     const target = purchaseCard?.querySelector('.pp-mega-bis-row');
     if (!purchaseCard || !target) return;

     const moveButton = () => {
       const candidate = [...purchaseCard.querySelectorAll('a,button')].find((el) =>
         /notify\s*me.*back\s*in\s*stock/i.test((el.textContent || '').replace(/\s+/g, ' ').trim())
       );
       if (candidate && !target.contains(candidate)) target.appendChild(candidate);
     };

     moveButton();
     if (root.dataset.megaBisObserver === 'true') return;
     root.dataset.megaBisObserver = 'true';
     const observer = new MutationObserver(moveButton);
     observer.observe(purchaseCard, { childList: true, subtree: true });
   });
 };
 placeMegaBackInStock();
 document.addEventListener('shopify:section:load', (event) => placeMegaBackInStock(event.target));

 document.querySelectorAll('[data-core-section]').forEach(init);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-core-section]').forEach(init));
})();
